/**
 * dijitalRozetDataItems.js — Dijital Rozet riza adiminda paylasilan veri
 * kalemlerinin tek kaynagi. DijitalRozetConsentSection.js (profil sekmesi)
 * ve ExamPage.js (sinav ici riza adimi) ayni listeyi burdan import eder.
 *
 * Ikon + i18n key eslesmesi disinda bir sey icermez; metinler
 * LanguageContext.js'teki profile.drConsent.dataItem.* anahtarlarindan gelir.
 */
import { User, Mail, GraduationCap } from 'lucide-react';

export const DR_DATA_ITEMS = [
  { icon: User, key: 'profile.drConsent.dataItem.name' },
  { icon: Mail, key: 'profile.drConsent.dataItem.email' },
  { icon: GraduationCap, key: 'profile.drConsent.dataItem.courses' },
];
